import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import DynamicPage from "./DynamicPage";
import AdminCMS from "./pages/AdminCMS";
import Login from "./components/Login";
import ProtectedRoute from "./components/ProtectedRoute";
import Register from "./components/Register";
import PasswordReset from "./components/PasswordReset";
import BlogPostPage from "./pages/BlogPostPage";
import DashboardContainer from "./components/DashboardContainer";
import ScrollToTop from "./components/ScrollToTop";

const App = () => {
    return (
        <Router>
            <Layout>
                <ScrollToTop />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/*" element={<DynamicPage />} />
                    <Route path="/blog/:slug" element={<BlogPostPage />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/register" element={<Register />} />
                    <Route path="/password-reset" element={<PasswordReset />} />
                    {/* Protected Routes */}
                    <Route
                        path="/members/dashboard"
                        element={
                            <ProtectedRoute>
                                <DashboardContainer />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/admin"
                        element={
                            <ProtectedRoute requiredRole="admin">
                                <AdminCMS />
                            </ProtectedRoute>
                        }
                    />
                </Routes>
            </Layout>
        </Router>
    );
};

export default App;
